import { Component } from '@angular/core';

@Component({
  selector: 'greco-cart-button',
  templateUrl: './cart-button.component.html',
  styleUrls: ['./cart-button.component.scss'],
})
export class CartButtonComponent {}
